

















































































































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bookingModule } from '@/store';
import { Vehicle, VehicleType } from '@/api';
import RelAutocomplete from '@/components/RelAutocomplete.vue';
import RelAutocompleteAsync from '@/components/RelAutocompleteAsync.vue';
import RelSelect from '@/components/RelSelect.vue';

@Component({
  components: {
    RelAutocomplete,
    RelAutocompleteAsync,
    RelSelect,
  },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;

  bookingVehicle: Vehicle | null = null;

  makeSelect: string = '';
  colourSelect: string = '';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredObject = [
    (v: VehicleType) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  get makes() {
    const defaultMakes = bookingModule.makes;
    defaultMakes.push('Other');
    return defaultMakes;
  }
  get colours() {
    const defaultColours = bookingModule.colours;
    defaultColours.push('Other');
    return defaultColours;
  }

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  vehicleScopeFactory() {
    return Vehicle.includes([]);
  }

  get vehicleWhere() {
    if (!this.booking || !this.booking.customer) {
      return;
    }
    return { owner: this.booking.customer.id };
  }

  vehicleTypeScopeFactory() {
    return VehicleType.includes([]).order({ name: 'asc' });
  }

  bookingBack() {
    this.$router.back();
  }

  async step3() {
    if (!this.booking) {
      return;
    }
    try {
      this.loading = true;

      if (this.booking.customer && this.booking.vehicle) {
        this.booking.vehicle.owner = this.booking.customer;
        if (this.booking.vehicle.rego) {
          this.booking.vehicle.rego = this.booking.vehicle.rego
            .toUpperCase()
            .replace(/\s/g, '');
        }
        if (this.makeSelect && this.makeSelect !== 'Other') {
          this.booking.vehicle.make = this.makeSelect;
        }
        if (this.colourSelect && this.colourSelect !== 'Other') {
          this.booking.vehicle.colour = this.colourSelect;
        }
        await this.booking.vehicle.save({
          with: ['vehicleType.id', 'owner.id'],
        });
      } else if (this.booking.rego) {
        this.booking.rego = this.booking.rego.toUpperCase().replace(/\s/g, '');
        if (this.makeSelect && this.makeSelect !== 'Other') {
          this.booking.make = this.makeSelect;
        }
        if (this.colourSelect && this.colourSelect !== 'Other') {
          this.booking.colour = this.colourSelect;
        }
      }

      bookingModule.setCompletedStep(3);
      this.$router.push({
        name: 'booking-step-4',
      });
    } catch (err) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  beforeMount() {
    if (this.booking && this.booking.customer) {
      if (this.booking.vehicle) {
        this.bookingVehicle = this.booking.vehicle;
      } else {
        this.booking.vehicle = new Vehicle();
      }
    }
  }

  mounted() {
    bookingModule.setCurrentStep(3);
    bookingModule.checkStatus();
  }

  @Watch('bookingVehicle')
  vehicleChanged() {
    if (!this.booking || !this.booking.customer) {
      return;
    }

    if (this.bookingVehicle) {
      this.booking.vehicle = this.bookingVehicle;

      if (this.makes.includes(this.booking.vehicle.make)) {
        this.makeSelect = this.booking.vehicle.make;
      } else if (this.booking.vehicle.make) {
        this.makeSelect = 'Other';
      } else {
        this.makeSelect = '';
      }

      if (this.colours.includes(this.booking.vehicle.colour)) {
        this.colourSelect = this.booking.vehicle.colour;
      } else if (this.booking.vehicle.colour) {
        this.colourSelect = 'Other';
      } else {
        this.colourSelect = '';
      }
    } else {
      this.booking.vehicle = new Vehicle();
      this.makeSelect = '';
      this.colourSelect = '';
      // @ts-ignore
      this.$refs.formStep3.resetValidation();
    }
  }
}
